<!-- 标题 -->
<template>
  <div class='cus_title_wrap'>{{text}}</div>
</template>

<script>
export default {
  name: 'CusTitle',
  props: {
    text: {
      type: String,
      default: '标题文字'
    }
  },
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.cus_title_wrap {
  padding: 0 15px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: #000;
  &::before {
    content: " ";
    position: relative;
    width: 4px;
    height: 20px;
    display: inline-block;
    border-radius: 2px;
    background: var(--background);
    top: 4px;
    margin: 0 8px 0 0;
  }
}
</style>